import * as React from "react";
import LinkButtonArray, { LinkItem } from "./LinkButtonArray";
import Image, { StaticImageData } from "next/image";
import { Card } from "../ui/card";
interface TwoColumnLayoutProps {
  title?: string;
  description?: string;
  imageSrc: StaticImageData;
  links: LinkItem[];
  baseUrl?: string;
}
const TwoColumnLayout: React.FC<TwoColumnLayoutProps> = ({
  imageSrc,
  links,
  baseUrl,
  title,
  description
}) => {
  return <Card className="relative flex h-auto flex-wrap items-center justify-center py-10 mobile:py-16 tablet:h-[70vh] tablet:overflow-hidden tablet:overflow-y-auto tablet:p-12" data-sentry-element="Card" data-sentry-component="TwoColumnLayout" data-sentry-source-file="TwoColumnLayout.tsx">
      <div className="absolute inset-0 top-1/2 flex h-full w-full -translate-y-1/2 items-center justify-center">
        <div className="relative h-[80%] w-full">
          <Image src={imageSrc} alt="Description for the image" layout="fill" objectFit="contain" className="pointer-events-none select-none opacity-30 blur-[1px]" data-sentry-element="Image" data-sentry-source-file="TwoColumnLayout.tsx" />
        </div>
      </div>

      <div className="z-10 w-full max-w-2xl px-8 mobile:w-2/3 mobile:px-0 wide:w-1/2">
        <div className="mb-8 flex flex-col gap-2">
          {title && <h2 className="text-4xl font-bold leading-none tracking-tight">{title}</h2>}
          {description && <p className="text-lg text-primary">{description}</p>}
        </div>
        <LinkButtonArray links={links} baseUrl={baseUrl} data-sentry-element="LinkButtonArray" data-sentry-source-file="TwoColumnLayout.tsx" />
      </div>
    </Card>;
};
export default TwoColumnLayout;